export var Color;
(function (Color) {
    Color["White"] = "white";
    Color["Black"] = "black";
    Color["Blue"] = "blue";
    Color["Red"] = "red";
    Color["Green"] = "green";
    Color["Gray"] = "gray";
})(Color || (Color = {}));
//# sourceMappingURL=color.js.map